import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import useStrategicContext from '@/api/useStrategicContext.ts';

const OnboardingGate: FC = () => {
  const { userProfile, isLoadingProfile } = useAuthContext();
  const orgId = userProfile?.org_id;
  const { data: strategicContext, isLoading: isLoadingContext } = useStrategicContext(orgId);

  // Wait for the profile to load before enabling the context query, so the
  // Outlet doesn't mount prematurely and get reset when the query enables.
  const loading = isLoadingProfile || (!!orgId && isLoadingContext);

  if (loading) return null;

  if (strategicContext) {
    return <Navigate to={Routes.DASHBOARD} />;
  }

  return <Outlet />;
};

export default OnboardingGate;
